module.exports = __webpack_public_path__ + "static/media/qingyang.fcf33e0e.png";